module.exports = __webpack_public_path__ + "img/B788F1B3-864D-46D2-942A-B8CD456B4B4B.c58818d3.svg";